import { call, put, select, takeLatest } from 'redux-saga/effects'

import {
  changePassword as changePasswordApi,
  sendPaswordResetLink as sendPaswordResetLinkApi,
  updatePassword as updatePasswordApi,
} from 'Service/Api'

import * as PasswordResetTypes from 'Redux/Types/PasswordResetTypes'
import * as PasswordResetActions from 'Redux/Actions/PasswordResetActions'

function* sendPaswordResetLink({ payload }) {
  const { params, resolver, rejector } = payload
  const { email } = params

  try {
    yield call(sendPaswordResetLinkApi, { username: email })
    yield put(PasswordResetActions.sendPasswordResetLinkSucceeded())
    resolver && resolver()
  } catch {
    const errorMessage = { email: 'Invalid email' }
    yield put(PasswordResetActions.sendPasswordResetLinkFailed(errorMessage))
    rejector && rejector()
  }
}

function* changePassword({ payload }) {
  const { params, rejector, resolver } = payload
  const { token, password: newPassword } = params
  try {
    yield call(changePasswordApi, { token, newPassword })
    yield put(PasswordResetActions.changePasswordSucceeded())
    if (resolver) {
      resolver()
    }
  } catch (error) {
    const errorMessage = JSON.parse(error.message)
    yield put(PasswordResetActions.changePasswordFailed(errorMessage))
    if (rejector) {
      rejector(errorMessage)
    }
  }
}

function* updatePassword({ payload }) {
  const { currentPassword, newPassword } = payload

  try {
    const { profile } = yield select(({ user }) => user)
    const updatedUser = { ...profile, oldPassword: currentPassword, password: newPassword }
    yield call(updatePasswordApi, updatedUser)
    yield put(PasswordResetActions.updatePasswordSuccess())
  } catch (error) {
    yield put(PasswordResetActions.updatePasswordFailed(JSON.parse(error.message)))
  }
}

export default function* passwordResetSaga() {
  yield takeLatest(PasswordResetTypes.CHANGE_PASSWORD, changePassword)
  yield takeLatest(PasswordResetTypes.UPDATE_PASSWORD, updatePassword)
  yield takeLatest(PasswordResetTypes.SEND_PASSWORD_RESET_LINK, sendPaswordResetLink)
}
